// extracted by mini-css-extract-plugin
export default {"form-control":"BaseInput_form-control__qxRDh","error":"BaseInput_error__Qf8HZ"};